import React, { useEffect, useState } from 'react'
import { Col, Panel, Row } from 'rsuite'

export default function MAndEProjectInfo({ schema }) {
  return (
    <>
      {schema && (
        <Panel
          bordered
          style={{
            backgroundColor: '#cccbca4d',
            border: '1px solid #4e4b488c',
            marginBottom: 20,
          }}
        >
          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 5 }}>
              <b>รหัสโครงการ : </b>
              {schema.projectCode}
            </Col>
            <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 5 }}>
              <b>ชื่อโครงการ : </b>
              {schema.projectName}
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 5 }}>
              <b>ผู้รับผิดชอบ : </b>
              {schema.responsinator}
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 5 }}>
              <b>ผู้รับทุน : </b>
              {schema.grantee}
            </Col>
            <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 5 }}>
              <b>พื้นที่ดำเนินการ : </b>
              {schema.projectArea}
            </Col>
            {schema.otherInfo && (
              <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 5 }}>
                <div dangerouslySetInnerHTML={{ __html: schema.otherInfo }} />
              </Col>
            )}
          </Row>
        </Panel>
      )}
    </>
  )
}
